import React, { useCallback, useEffect } from 'react';
import classNames from 'classnames';

// eslint-disable-next-line local-rules/invalid-import
import { useUpdateAssesmentBatchAssociationMutation } from '@satManagement/services/courseAssessmentMenteeService';
import { Icon, Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

function SaveBatchDetailButton({ data }) {
  const [updateBatchAssociation, { isSuccess, error, isLoading: isCreating }] =
    useUpdateAssesmentBatchAssociationMutation();

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Succesfully saved');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error.data?.message || 'Failed to save');
    }
  }, [error]);

  const handleOnClick = useCallback(() => {
    updateBatchAssociation({ data });
  }, [data, updateBatchAssociation]);

  return (
    <Tappable
      onClick={handleOnClick}
      disabled={isCreating || Object.keys(data)?.length === 0}
      className={classNames('btn btn-outlined btn-primary m-r-10')}
    >
      <Icon name="add" />
      Save update
    </Tappable>
  );
}

export default SaveBatchDetailButton;
